import React from "react"
import PropTypes from "prop-types"
import CTAs from "../common/Ctas"
import Image from "../common/Image"
import SmartColour from "../../utils/ColourHandler"
import SmartText from "../../utils/TextHandler"
import SmartWidth from "../../utils/ImageWidthHandler"
import OTLink from "../common/otLink"

/********************************
<Project />
/********************************
Version: 1
Created: 12 02 2026
Updated: 12 02 2026
Author: Richy Pears
/********************************
Returns a project card for use in
related products
/********************************/

const Project = ({ columns, node, theme }) => {
  if (!node) return null // Escape hatch

  const data = node.content

  const imageWidth = SmartWidth(columns && columns, "width") // This returns optimum widths for our images

  const colour = SmartColour(theme)

  return (
    <div
      className={`flex flex-col p-3 h-full
        ${
          columns?.xs && columns?.xs !== "auto"
            ? ` w-1/${columns.xs} shrink-0`
            : ` shrink`
        }
        ${
          columns?.sm && columns?.sm !== "auto"
            ? ` sm:w-1/${columns.sm} sm:shrink-0`
            : ` sm:shrink`
        }
        ${
          columns?.md && columns?.md !== "auto"
            ? ` md:w-1/${columns.md} md:shrink-0`
            : ` md:w-full md:shrink`
        }
        ${
          columns?.lg && columns?.lg !== "auto"
            ? ` lg:w-1/${columns.lg} lg:shrink-0`
            : ` lg:w-full lg:shrink`
        }
        ${
          columns?.xl && columns?.xl !== "auto"
            ? ` xl:w-1/${columns.xl} xl:shrink-0`
            : ` xl:w-full xl:shrink`
        }
      `}
    >
      <OTLink to={node.full_slug} className="flex flex-col w-full h-full">
        <div
          className={`flex flex-col w-full h-full ${
            colour.classes ? colour.classes : `text-black bg-white`
          }`}
        >
          {data?.image && (
            <div className="aspect-16x9 bg-white shrink-0">
              <Image
                aspect="16x9"
                className="min-w-full"
                sizes={imageWidth}
                src={
                  data?.preview?.filename ||
                  data?.seo_image?.filename ||
                  data?.image?.filename
                }
              />
            </div>
          )}
          <div
            className={`flex flex-col h-full p-3 text-${
              data?.align ? data?.align : ""
            }`}
          >
            {data?.title && <h4 className="m-0">{data?.title}</h4>}
            {data?.client && (
              <h6 className="uppercase font-black mb-6 text-white/50">
                {data?.client}
              </h6>
            )}
            {data?.tags && data?.tags?.value?.length > 0 && (
              <p className="m-0 mt-auto text-sm uppercase flex flex-col">
                {data?.tags?.value?.map((tag, index) => (
                  <>
                    {index < 3 && (
                      <span className="font-bold whitespace-nowrap">{tag}</span>
                    )}
                  </>
                ))}
              </p>
            )}
          </div>
        </div>
      </OTLink>
    </div>
  )
}

export default Project

Project.defaultProps = {
  columns: null,
  node: null,
  theme: "white",
}

Project.propTypes = {
  columns: PropTypes.object,
  node: PropTypes.object,
  theme: PropTypes.string,
}
